exports = module.exports = require("../../../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, ".tag[data-v-5cade07f]{--bg-opacity:1;background-color:#4299e1;background-color:rgba(66,153,225,var(--bg-opacity));--text-opacity:1;color:#fff;color:rgba(255,255,255,var(--text-opacity));letter-spacing:.025em;text-transform:uppercase;border-radius:.25rem;border-width:0;padding:.25rem;margin-right:.25rem}", ""]);

// exports
